/* eslint-disable import/prefer-default-export */
export const EN = {
  en: {
    generals: {
      seework: "See the work| {1} See the work",
      offices: "All Offices",
      read: "Read the article",
      related: "Related Projects",
      "related-news": "Recent News",
      readmore: "Read more",
      seemore: "See more",
      getcontact: "Get in contact",
      ourclients: "Our Clients",
      apply: "Apply",
      jobsfounded: "Coming Soon...",
      error: "Something went wrong, try again...",
      employeesfounded: "No employees found...",
      clientsfounded: "No clients found...",
      newsfounded: "No news founded...",
      contactsfounded: "No contacts found...",
    },
    menus: {
      work: "Work",
      news: "News",
      about: "About",
      contact: "Contact",
    },
    search: {
      placeholder: "What are you looking for?",
      results: "result found | {2} results found",
      filter: "Filter",
      columns: {
        offices: "Office",
        types: "Type",
        customers: "Client",
        years: "Year",
      },
    },
    singleWork: {
      office: "Office",
      date: "Date",
      client: "Client",
    },
    footer: {
      copyright: "All Rights Reserved",
      followus: "Follow us on",
      weare: "We are",
    },
    contact: {
      talkwithus: "Talk <br /> With us",
      workwithus: "Work <br/> With us",
      talents: "New Talents",
      talentdescription:
        "Come to work in the world’s most creative agency. <br /> Or, if you don’t think we are the most creative agency in the world: <br /> Come to work at DAVID. It’s your chance to transform it into the world’s most creative agency.",
      general: "General contact",
      vacanciesnotfound:
        "At the moment we don't have an open selection process, <br />but you can always send us hello.",
    },
  },
};
